import React, {ReactElement} from "react";
import {connect} from "react-redux";
import "./TasksScroll.scss";
import StoreState from "../../../interfaces/store/storeState";
import {TaskEntity} from "../../../interfaces/store/actions/payload/task";
import TaskContainer from "../TaskContainer/TaskContainer";

interface StateProps {
    tasks: TaskEntity[]
}

type Props = StateProps;

const TasksScroll: React.FC<StateProps> = (props: Props): ReactElement => {
    const {tasks}: Props = props;
    return (
        <div className="df-tasks-scroll">
            {
                tasks.map((task: TaskEntity) => (
                    <TaskContainer task={task}/>
                ))
            }
        </div>
    );
};

function mapStateToProps({job: {tasks}}: StoreState): StateProps {
    return {
        tasks,
    };
}

export default connect(mapStateToProps)(TasksScroll);
